// components/Icon.tsx
import React from "react";

import subtract from "@/public/icon/Subtract.svg";
import bars from "@/public/icon/bars.svg";
import close from "@/public/icon/close.svg";
import more from "@/public/icon/more.svg"
import user from "@/public/icon/user.svg"

type iconType = 'subtract' | 'bars' | 'close' | 'more' | undefined

export interface IconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  icon: iconType
  src?: string
}

const Icon = React.forwardRef<HTMLImageElement, IconProps>(
  ({ icon, src, alt, className = "", ...rest }, ref) => {
    const mergedClassName = `icon ${className}`.trim();

    let iconSrc: string
    switch(icon){
      case "subtract": iconSrc = user.src; break;
      case "bars":     iconSrc = bars.src;     break;
      case "close":    iconSrc = close.src;    break;
      case "more":     iconSrc = more.src;     break;
      default: 
        iconSrc = src || ""
    }

    return <img ref={ref} src={iconSrc} alt={alt} className={mergedClassName} {...rest} />;
  }
);

Icon.displayName = "Icon";

export default Icon;